import React from 'react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const sizeClasses = {
  sm: 'w-1.5 h-1.5',
  md: 'w-2.5 h-2.5',
};

export default function JiraDot({ dotColor, showPulse, size = 'md' }) {
  const sizeClass = sizeClasses[size] ?? sizeClasses.md;
  return (
    <span className={`relative inline-block align-middle ${size === 'sm' ? '' : 'mr-2'}`}>
      <span
        className={classNames(
          'inline-block rounded-full',
          sizeClass,
          dotColor,
          showPulse ? 'animate-pulse' : ''
        )}
        aria-hidden="true"
      />
    </span>
  );
}